/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: ArchiveFeatureDialog.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-FEATURES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * ArchiveFeatureDialog - Frontend UI module: ArchiveFeatureDialog.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: контракты функций, парные END_METHOD, блок архивации.
 * END_CHANGE_SUMMARY
 */

import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/* START_METHOD_ArchiveFeatureDialog */
/* START_CONTRACT: ArchiveFeatureDialog
 * PURPOSE: Диалог подтверждения архивации задачи.
 * INPUTS: { open: boolean, onClose: ()=>void, onConfirm: (id)=>Promise, feature: Feature }.
 * OUTPUTS: { JSX.Element|null - диалог }.
 * SIDE_EFFECTS: вызов onConfirm (HTTP наверх); локальный state.
 * LINKS: M-FE-FEATURES
 * END_CONTRACT: ArchiveFeatureDialog
 */
export default function ArchiveFeatureDialog({ open, onClose, onConfirm, feature }) {
  const [loading, setLoading] = useState(false);

  if (!feature) return null;

  /* START_METHOD_handleConfirm */
  /* START_CONTRACT: handleConfirm
   * PURPOSE: Архивировать задачу; при успехе закрыть диалог.
   * INPUTS: {}.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: onConfirm (HTTP); setLoading; onClose.
   * LINKS: M-FE-FEATURES
   * END_CONTRACT: handleConfirm
   */
  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm(feature.id);
      /* START_BLOCK_ARCHIVE_OK */
      onClose();
      /* END_BLOCK_ARCHIVE_OK */
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleConfirm */

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: '1rem' }}>Архивирование задачи</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Архивировать задачу &laquo;{feature.name}&raquo;?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color="warning"
          size="small"
          onClick={handleConfirm}
          disabled={loading}
        >
          Архивировать
        </Button>
        <Button size="small" onClick={onClose} disabled={loading}>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>
  );
}
/* END_METHOD_ArchiveFeatureDialog */
